// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDqD7V64u5MF6zNrjBIKc7GU7txX9UYKk0',
    authDomain: 'ats2000dev.firebaseapp.com',
    databaseURL: 'https://ats2000dev.firebaseio.com',
    projectId: 'ats2000dev',
    storageBucket: 'ats2000dev.appspot.com',
    messagingSenderId: '192061103038',
    appId: '1:192061103038:web:19890db761802dda9477ef',
    measurementId: 'G-VYEFTQTN90'
  },
  // apiEndPoint: 'http://localhost:3000/api/'
  apiEndPoint: 'https://ats2000crmdevserver.herokuapp.com/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
